export default function SalesMethodSection() {
  const methods = [
    {
      title: '委託販売（仲介）',
      icon: 'ri-handshake-line',
      description: '仲介のようなイメージです。WEBに情報を掲載し、買主様が現れた際に譲渡手続きを行います。',
      features: [
        '成約率約8割',
        'うち5割程度は3ヶ月以内に成約',
        '目標期間：3ヶ月〜6ヶ月',
        '幅広い買い手候補にアプローチ可能'
      ],
      color: 'from-teal-500 to-cyan-500'
    },
    {
      title: '直接買取',
      icon: 'ri-shopping-cart-line',
      description: '弊社が直接買取を行います。買取できない場合や、おすすめしない場合もございます。',
      features: [
        'スピーディーな取引',
        '確実な売却',
        '条件についてご相談可能',
        '変更登記などの調整あり'
      ],
      color: 'from-cyan-500 to-blue-500'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-teal-50 rounded-full mb-6">
            <i className="ri-exchange-line text-teal-600 text-xl mr-3"></i>
            <span className="text-sm font-bold text-teal-600">SALES METHOD</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            2つの<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">売却方法</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            お客様の状況に応じて、最適な売却方法をご提案いたします
          </p>
        </div>

        {/* Methods Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {methods.map((method, index) => (
            <div key={index} className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border-2 border-gray-100 hover:border-teal-500 transition-all duration-300 hover:shadow-2xl">
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${method.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <i className={`${method.icon} text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-black text-gray-900 mb-4">{method.title}</h3>

              {/* Description */}
              <p className="text-base text-gray-700 mb-6 leading-relaxed">{method.description}</p>

              {/* Features */}
              <div className="space-y-3">
                {method.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className={`w-6 h-6 bg-gradient-to-br ${method.color} rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5`}>
                      <i className="ri-check-line text-sm text-white"></i>
                    </div>
                    <span className="text-sm text-gray-700 font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
